module.exports = __webpack_public_path__ + "static/img/good_browser.45ecfbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/good_browser.png
// module id = 94my
// module chunks = 1